import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-estados-admin',
  templateUrl: './estados-admin.component.html',
  styleUrls: ['./estados-admin.component.css']
})
export class EstadosAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecRoles = []; public vecAddPermiso = []; public vecAddUsuario = [];
  public vecVerRoles = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarRoles(1); this.cargarVerUsuarios();
  }
  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarRoles(op) {
    this.reiniciarTabla();

    this.vecRoles = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(5, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objRol of res.roles) {
        if (op == 1) {
          if (objRol.rolPersona == 1)
            this.agregarEstadosVec(
              objRol.intIdPersona, objRol.strCedula, objRol.strNombres, objRol.strApellidos, objRol.strDependencia, objRol.estadoPersona, objRol.intIdRol,
              objRol.strNombre, objRol.strDescripcion, objRol.estadoRol, objRol.rolPersona == 1 ? "Activo" : "Inactivo", objRol.rolPersona == 1 ? "Desactivar" : "Activar",
              objRol.rolPersona
            );
        }
        else
          this.agregarEstadosVec(
            objRol.intIdPersona, objRol.strCedula, objRol.strNombres, objRol.strApellidos, objRol.strDependencia, objRol.estadoPersona, objRol.intIdRol,
            objRol.strNombre, objRol.strDescripcion, objRol.estadoRol, objRol.rolPersona == 1 ? "Activo" : "Inactivo", objRol.rolPersona == 1 ? "Desactivar" : "Activar",
            objRol.rolPersona
          );
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //AGREGAR LOS ESTADOS DE LOS USUARIOS A SER MOSTRADOS SEGUN EL ESTADO
  agregarEstadosVec(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13) {
    this.vecRoles.push({
      codPersona: dato1, cedPersona: dato2, nombPersona: dato3, apePersona: dato4, unidad: dato5, estPersona: dato6, codRol: dato7, nombRol: dato8, descRol: dato9,
      estRol: dato10, estAsigna: dato11, etiqueta: dato12, idRolPersona: dato13
    });
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO PERMISO
  async modalNuevoRol(nameMod) {
    this.tituloModal = "Asignar un rol a un usuario"; this.accion = 4;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE CARGA TODOS LOS USUARIOS REGISTRADOS EN EL SISTEMA
  async cargarVerUsuarios() {
    this.vecAddUsuario = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionUsuarios(1, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.usuario) {
        if (res.usuario[i]['intEstado'] == 1) {
          this.vecAddUsuario.push({
            codigo: res.usuario[i]['intIdPersona'], nombres: res.usuario[i]['strNombres'] + " " + res.usuario[i]['strApellidos']
          });
        }
      }
    }
  }
  //FUNCION PARA CARGAR LOS ROLES DISPONIBLES AL USUARIO SELECCIONADO
  async cargarOpciones(cedula) {
    this.vecVerRoles = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(3, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.roles) {
        if (res.roles[i]['intEstado'] == 1) {
          this.cargarRolVector(cedula, res.roles[i]['intIdRol'], res.roles[i]['strNombre']);
        }
      }
    }
  }
  //FUNCION PARA CARGAR EL VECTOR CON LOS ROLES DISPONIBLES AL USUARIO SELECCIONADO
  async cargarRolVector(cedula, idRol, nombRol) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(6, cedula, idRol).subscribe(translated => {
        resolve(translated)
      }));
    if (!res.success) {
      this.vecVerRoles.push({
        codigo: idRol, nombre: nombRol
      });
    }
  }
  //FUNCION QUE CAMBIA EL ESTADO DEL ROL ASIGNADO AL PERFIL
  cambiaEstado(estado) {
    this.srvInsert.ingresoGestionRoles(estado['codPersona'], estado['codRol'], estado['idRolPersona'] == 1 ? 2 : 1, 'na', 'na', 3).subscribe(res => {
      if (res.rol) {

        this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'SUPER ADMINISTRADOR', 'ingresoGestionRol()', 'Cambiar el estado de un rol asignado a una persona',
          3, ' Usuario - ' + estado['nombPersona'] + '' + estado['apePersona'] + '; Cod Usuario - ' + estado['codPersona'] + '; Cod Rol - ' + estado['codRol'] + '; Estado - '
        + estado['idRolPersona'], 1).subscribe(res => { });

        this.alerti.success('Estado editado con éxito');
        this.reiniciarTabla();
        this.cargarRoles(1);
      }
      else
        this.alerti.error("No se puede agregar la actividad");
    });
  }
  //FUNCION QUE PERMITE ASIGNAR UNA UN ROL A UN USUARIO
  agregarPermisoRol() {
    this.srvInsert.ingresoGestionRoles(this.vecAddPermiso[0]['usuario'], this.vecAddPermiso[0]['rol'], this.vecAddPermiso[0]['estado'],
      this.vecAddPermiso[0]['modUser'], this.vecAddPermiso[0]['modRol'], this.accion).subscribe(res => {
        if (res.rol) {

          this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'SUPER ADMINISTRADOR', 'ingresoGestionRol()', 'Asignar / Editar un rol a usuario', this.accion,
            'Cod Usuario - ' + this.vecAddPermiso[0]['usuario'] + '; Cod Rol - ' + this.vecAddPermiso[0]['rol'] + '; Cod Estado - ' + this.vecAddPermiso[0]['estado'] +
            '; Cod Usuario Mod - ' + this.vecAddPermiso[0]['modUser'] + '; Cod Rol Mod - ' + this.vecAddPermiso[0]['modRol'], 1).subscribe(res => { });

          this.alerti.success('Rol asignado correctamente');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarRoles(1);
        }
        else
          this.alerti.error("No se pudo asignar el rol.");
      });
  }

  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR LOS ROLES ASIGNADOS AL USUARIO SELECCIONADO
  modalVerRol(nameMod, objRol) {
    this.borrarDatos();
    this.tituloModal = "Modificar el rol del usuario"; this.accion = 5;
    this.buscarRolUsuario(objRol);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION PARA CARGAR EL VECTOR CON LOS ROLES DISPONIBLES AL USUARIO SELECCIONADO
  async buscarRolUsuario(datoRol) {
    this.cargando.abrir();
    this.vecAddPermiso = [];
    this.cargarOpciones(datoRol['codPersona']);
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(6, datoRol['codPersona'], datoRol['codRol']).subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecVerRoles.push({ codigo: res.roles[0]['intRol'], nombre: res.roles[0]['strNombre'] });
      this.vecAddPermiso.push({
        usuario: res.roles[0]['intIdPersona'], rol: res.roles[0]['intRol'], estado: res.roles[0]['estRolUser'],
        modUser: res.roles[0]['intIdPersona'], modRol: res.roles[0]['intRol']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblEstados').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION PARA INSTANCIAR LAS VARIABLES
  borrarDatos() {
    this.vecAddPermiso = [];
    this.vecAddPermiso.push({ usuario: 0, rol: 0, estado: 1, modUser: 0, modRol: 0 });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
